import React, { lazy, Suspense, useContext } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { LoadingSpinner } from 'cprime-foundational-components';
import { Roles } from 'context/Roles.context';

const ErrorNotFound = lazy(() => import('./pages/ErrorNotFound/ErrorNotFound'));
const ExecutiveDashboard = lazy(() => import('./pages/ExecutiveDashboard/ExecutiveDashboard'));

const Router = () => {
  const auth = useAuth();
  const { permissions } = useContext(Roles);

  switch (auth.activeNavigator) {
    case 'signoutRedirect':
    case 'signinSilent':
    case 'signinRedirect':
      return <div>Redirecting to Login...</div>;
  }

  if (auth.isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (auth.error) {
    return <div>Oops... {auth.error.message}</div>;
  }

  if (!auth.isAuthenticated) {
    const pathname = window.location.pathname;
    if (pathname !== '/') {
      sessionStorage.setItem('cube-pathname', window.location.pathname);
    }
    auth.signinRedirect();
    return null;
  }

  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingSpinner fullScreen />}>
        <Routes>
          {/* to be changed once we implement other pages */}
          <Route index path="/" element={<ExecutiveDashboard />} />
          <Route path="/executive-dashboard" element={<ExecutiveDashboard />} />
          {permissions && <Route path="*" element={<ErrorNotFound />} />}
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
